import { useTranslation } from "@warpme/i18n"
import { WARP_ME_EXTERNAL_LINKS } from "@warpme/ui"
import type { FC } from "react"

import {
  HeaderMenu,
  HeaderMenuActionLink,
  HeaderMenuCloseButton,
  HeaderMenuDrawer,
  HeaderMenuDrawerLink,
} from "@/components/header-menu"

const SECTION_TITLE_CLASS =
  "flex h-[52px] items-end bg-background px-4 pb-2 text-label-lg font-light leading-[1.35] text-text"
const MENU_ITEM_CLASS =
  "flex h-11 items-center border-b border-border px-4 text-body-md font-semibold leading-[1.5] text-text"
const OTHER_MENU_ITEM_CLASS =
  "flex h-11 items-center border-b border-border px-4 text-body-sm font-light leading-[1.35] text-text"

export const NavigationMenu: FC = () => {
  const { t } = useTranslation("consumer")

  return (
    <HeaderMenu>
      <HeaderMenuActionLink to="/account">{t("navigation.account")}</HeaderMenuActionLink>
      <HeaderMenuDrawer contentClassName="w-[calc(100%-60px)] max-w-none gap-0 border-l border-border bg-bg-white p-0 shadow-right">
        <div className="relative flex h-full flex-col overflow-y-auto pt-12">
          <section className="flex flex-col">
            <p className={SECTION_TITLE_CLASS}>{t("navigation.ticketsAndAccount")}</p>
            <HeaderMenuDrawerLink to="/" className={MENU_ITEM_CLASS}>
              {t("navigation.ticketList")}
            </HeaderMenuDrawerLink>
            <HeaderMenuDrawerLink to="/purchases" className={MENU_ITEM_CLASS}>
              {t("navigation.purchaseHistory")}
            </HeaderMenuDrawerLink>
            <HeaderMenuDrawerLink to="/account" className={MENU_ITEM_CLASS}>
              {t("navigation.accountInfo")}
            </HeaderMenuDrawerLink>
          </section>

          <section className="flex flex-col">
            <p className={SECTION_TITLE_CLASS}>{t("navigation.support")}</p>
            <a
              href={WARP_ME_EXTERNAL_LINKS.support.consumerFaq}
              target="_blank"
              className={MENU_ITEM_CLASS}
              rel="noreferrer"
            >
              {t("navigation.faq")}
            </a>
            <a
              href={WARP_ME_EXTERNAL_LINKS.support.company}
              target="_blank"
              className={MENU_ITEM_CLASS}
              rel="noreferrer"
            >
              {t("navigation.company")}
            </a>
            <a
              href={WARP_ME_EXTERNAL_LINKS.support.contact}
              target="_blank"
              className={MENU_ITEM_CLASS}
              rel="noreferrer"
            >
              {t("navigation.contact")}
            </a>
          </section>

          <section className="flex flex-col">
            <p className={SECTION_TITLE_CLASS}>{t("navigation.other")}</p>
            <a
              href={WARP_ME_EXTERNAL_LINKS.legal.consumerTerms}
              target="_blank"
              className={OTHER_MENU_ITEM_CLASS}
              rel="noreferrer"
            >
              {t("navigation.terms")}
            </a>
            <a
              href={WARP_ME_EXTERNAL_LINKS.legal.privacyPolicy}
              target="_blank"
              className={OTHER_MENU_ITEM_CLASS}
              rel="noreferrer"
            >
              {t("navigation.privacy")}
            </a>
            <a
              href={WARP_ME_EXTERNAL_LINKS.legal.specifiedCommercialTransactions}
              target="_blank"
              className={OTHER_MENU_ITEM_CLASS}
              rel="noreferrer"
            >
              {t("navigation.commercialLaw")}
            </a>
          </section>

          <div className="absolute inset-x-0 top-0 flex h-12 items-center justify-end bg-bg-white pr-[6px]">
            <HeaderMenuCloseButton className="flex size-9 items-center justify-center rounded-full bg-highlight backdrop-blur-[10px]" />
          </div>
        </div>
      </HeaderMenuDrawer>
    </HeaderMenu>
  )
}
